export default {
  /**
   * Biến check xem có tích vào option "Không hiển thị lần sau" của message sinh phiếu thu, chứng từ khi lập giấy rút
   * false: Không hiển thị lần sau, true: Có hiển thị lần sau
   */
  IsShowMessageGenerateInvoiceNextTime: 'IsShowMessageGenerateInvoiceNextTime',

  /**
   * Biến lưu tên chứng từ được chọn để lần sau mặc định sinh sau khi cất chứng từ Rút dự toán chuyển khoản lương, bảo hiểm
   */
  FormDetailGenerateInvoiceName: 'FormDetailGenerateInvoiceName',

  /**
   * Biến check xem có tích vào option "Không hiển thị lần sau" của message thông báo khi chuyển ký
   * false: Không hiển thị lần sau, true: Có hiển thị lần sau
   * tvhien 12/01/2023
   */
  IsShowMessageChangePeriod: 'IsShowMessageChangePeriod',
};
